/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GroupChat = zod.object({
  reachHome: zod
    .string()
    .min(1)
    .describe(
      "The region whose Reach holds the thread: the group's home, where its chat lives. A member homed in another region opens it over their own region's Reach, which links to this one.",
    ),
  reachSpaceId: zod.uuid(),
  reachThreadId: zod.uuid(),
});

export type GroupChat = zod.input<typeof GroupChat>;
export type GroupChatOutput = zod.output<typeof GroupChat>;
